import { supabase } from '../lib/supabase';

interface OAuthProviderConfig {
  provider: string;
  client_id: string;
  redirect_uris: Record<string, string>;
}

type OAuthConfigMap = Record<string, OAuthProviderConfig>;

let cachedConfig: OAuthConfigMap | null = null;

async function loadConfig(): Promise<OAuthConfigMap> {
  if (cachedConfig) return cachedConfig;

  const { data, error } = await supabase
    .from('oauth_config')
    .select('provider, client_id, redirect_uris');

  if (error || !data) {
    throw new Error('Failed to load OAuth configuration from database');
  }

  const map: OAuthConfigMap = {};
  for (const row of data) {
    map[row.provider] = row as OAuthProviderConfig;
  }

  cachedConfig = map;
  return map;
}

export async function getGoogleClientId(): Promise<string> {
  const config = await loadConfig();
  return config.google?.client_id || '';
}

export async function getGoogleRedirectUri(type: 'calendar' | 'meet' | 'email'): Promise<string> {
  const config = await loadConfig();
  return config.google?.redirect_uris?.[type] || '';
}

export async function getMicrosoftClientId(): Promise<string> {
  const config = await loadConfig();
  return config.microsoft?.client_id || '';
}

export async function getMicrosoftRedirectUri(type: 'calendar' | 'teams' | 'email'): Promise<string> {
  const config = await loadConfig();
  return config.microsoft?.redirect_uris?.[type] || '';
}

export async function getZoomClientId(): Promise<string> {
  const config = await loadConfig();
  return config.zoom?.client_id || '';
}

export async function getZoomRedirectUri(): Promise<string> {
  const config = await loadConfig();
  return config.zoom?.redirect_uris?.default || '';
}
